import BaseError from './BaseError';

class ApplicationError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('ApplicationError', message, fileName, lineNumber);
  }
}

export default ApplicationError;
